import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import axios from "axios";
import ReactPaginate from "react-paginate";
import Topbar from "../../components/Topbar";
import Sidebar from "../../components/Sidebar";
import ConfirmModal from "../../components/ConfirmModal"; // Import Reusable Modal

import "../../assets/ListingModal.css";

function CouponList() {
  const [couponList, setCouponList] = useState([]);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [showModal, setShowModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const token = sessionStorage.getItem("token");

  const fetchCouponList = async () => {
    if (!token) {
      toast.error("No token provided!");
      return;
    }

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_APIURL}api/coupon/list`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setCouponList(response?.data?.data || []);
    } catch (error) {
      toast.error(
        "Error fetching data: " +
          (error.response?.data?.message || error.message)
      );
    }
  };

  const handleDeleteCoupon = async () => {
    if (!token || !deleteId) {
      toast.error("No token provided or invalid ID!");
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_APIURL}api/coupon/delete/${deleteId}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.ok) {
        toast.success("Coupon deleted successfully!");
        fetchCouponList();
      } else {
        const data = await response.json();
        toast.error(data.message || "Failed to delete Coupon");
      }
    } catch (error) {
      toast.error("Something went wrong! Please try again later.");
    }

    setShowModal(false);
  };

  useEffect(() => {
    fetchCouponList();
  }, []);

  return (
    <>
      <Topbar />
      <Sidebar />
      <main id="main" className="main">
        <div className="pagetitle">
          <h1>Coupon List</h1>
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to={"/"}>Home</Link>
              </li>
              <li className="breadcrumb-item active">Coupon List</li>
            </ol>
          </nav>
        </div>

        <section className="section">
          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body">
                  <div className="datatable-container overflow-auto">
                    <table className="table datatable table-bordered table-striped">
                      <thead>
                        <tr>
                          <th>SL</th>
                          <th>Coupon Type</th>
                          <th>Code</th>
                          <th>Value</th>
                          <th>Starting Date</th>
                          <th>Ending Date</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {couponList.length > 0 ? (
                          couponList.map((item, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{item.type}</td>
                              <td>{item.code}</td>
                              <td>{item.value}</td>
                              <td>
                                {new Date(
                                  item.starting_date
                                ).toLocaleDateString("en-GB")}
                              </td>
                              <td>
                                {new Date(item.ending_date).toLocaleDateString(
                                  "en-GB"
                                )}
                              </td>
                              <td>
                                <div className="d-flex gap-2">
                                  <Link to={`/coupon/edit/${item._id}`}>
                                    <i className="bi bi-pencil-square text-primary"></i>
                                  </Link>
                                  <Link
                                    onClick={() => {
                                      setDeleteId(item._id);
                                      setShowModal(true);
                                    }}
                                  >
                                    <i className="bi bi-trash text-danger"></i>
                                  </Link>
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="7" className="text-center">
                              No matching records found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      {/* Reusable Delete Confirmation Modal */}
      <ConfirmModal
        show={showModal}
        onHide={() => setShowModal(false)}
        onConfirm={handleDeleteCoupon}
        title="Confirm Deletion"
        message="Are you sure you want to delete this coupon?"
      />
    </>
  );
}

export default CouponList;
